export default {"src":"/_next/static/media/pencilBig.a48c4847.svg","height":28,"width":25,"blurWidth":0,"blurHeight":0};